// Edit & Override Audit — who changed which field on which supplier-statement line,
// old value -> new value, when. Sourced from the audit_events accountability trail
// (one row per changed field). First report in the "audit" section.
export const audit_edits = {
   id: "audit_edits",
   title: "Edit & Override Audit",
   family: "audit_edits",
   section: "audit",
   endpoint: "/runauditedits.sz",
   defaultSort: { key: "changed_on", dir: "desc" },
   groupBy: ["changed_by"],
   groupOptions: [
      { value: "changed_by", label: "User" },
      { value: "supplier",   label: "Supplier" },
      { value: "field",      label: "Field" },
   ],
   categoryField: "field",
   categoryLabel: "Field",
   params: [
      { key: "period", type: "month", label: "Period" },
      { key: "locations", type: "multiselect", label: "Locations" },
      { key: "suppliers", type: "multiselect", label: "Suppliers" },
   ],
   summary: [
      { key: "changes", label: "Field changes", type: "int", agg: "count" },
   ],
   columns: [
      { key: "changed_on", label: "Changed on", type: "text",  align: "left" },
      { key: "changed_by", label: "User",       type: "text",  align: "left" },
      { key: "supplier",   label: "Supplier",   type: "text",  align: "left" },
      { key: "location",   label: "Location",   type: "text",  align: "left" },
      { key: "invoice_no", label: "Invoice #",  type: "text",  align: "left" },
      { key: "field",      label: "Field",      type: "label", align: "left" },
      { key: "old_value",  label: "Old value",  type: "text",  align: "left" },
      { key: "new_value",  label: "New value",  type: "text",  align: "left" },
   ],
};
